import Text from 'common-components/Text'
import { SHADOWS } from 'styles/consts'
import styled from 'styled-components'

export const LoadingGradientWrapper = styled.div<{
  $size: number
  $position: 'absolute' | 'relative'
}>`
  position: ${({ $position }) => $position};
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  background: rgba(255, 255, 255, 0.64);
  border-radius: 50%;
  box-shadow: ${SHADOWS.card};

  .gradient {
    width: 110%;
    height: 110%;
    flex-shrink: 0;
    z-index: 0;
    position: absolute;
    animation: spinning 1.5s infinite linear;
    @keyframes spinning {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`
export const LoadingGradientOverlay = styled.span`
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  background-color: rgba(255, 255, 255, 0.96);
  border-radius: 50%;
`

export const LoadingGradientText = styled(Text)`
  font-variant: tabular-nums;
`
